module.exports = __webpack_public_path__ + "img/keepkey.d7083f29.png";